<template>
  <div class="swiper-card card-finalise">
    <div class="corner-radius-blur"></div>
    <div class="onboarding-content">
      <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M49.3372 2.47648C49.1539 1.55998 48.44 0.846074 47.5235 0.662774C43.1823 -0.20549 36.5256 -0.755391 30.0909 2.56331C26.232 4.56031 22.6335 7.85007 19.7007 12.9632H11.8768C10.2464 12.9632 8.74142 13.8121 7.9021 15.211L2.79868 23.72C1.56383 25.7845 3.04951 28.399 5.44204 28.399H15.427C18.8325 28.399 21.6013 31.1678 21.6013 34.5733V44.5583C21.6013 46.9605 24.2157 48.4366 26.2802 47.2017L34.7891 42.0983C36.188 41.2589 37.0369 39.7539 37.0369 38.1235V30.2995C42.1596 27.3667 45.4494 23.7682 47.4367 19.9093C50.7554 13.4745 50.2055 6.8178 49.3372 2.47648ZM32.4062 32.557V38.1332L26.232 41.8378V34.6505C28.4798 34.033 30.5347 33.3384 32.4062 32.5666V32.557ZM25.2672 30.1066C24.1867 27.7333 22.2766 25.8135 19.8937 24.733C22.8458 14.1305 27.6019 9.05599 32.2133 6.67309C36.6414 4.38666 41.3396 4.37701 45.0635 4.92691C45.623 8.6508 45.6037 13.3491 43.3173 17.7772C40.9344 22.3887 35.86 27.1448 25.2576 30.0969L25.2672 30.1066ZM15.3595 23.7682H8.17223L11.8768 17.5939H17.4529C16.6811 19.4655 15.9865 21.5204 15.3691 23.7682H15.3595ZM39.3523 14.5068C39.3523 12.3747 37.6254 10.6478 35.4934 10.6478C33.3613 10.6478 31.6344 12.3747 31.6344 14.5068C31.6344 16.6388 33.3613 18.3657 35.4934 18.3657C37.6254 18.3657 39.3523 16.6388 39.3523 14.5068ZM14.6938 46.3045C17.7327 43.2656 17.7327 38.3454 14.6938 35.3065C11.6549 32.2676 6.73478 32.2676 3.69588 35.3065C0.67628 38.3261 0.0781471 44.1821 0.000968742 47.5008C-0.0376204 48.9093 1.08147 50.0284 2.49962 49.9995C5.82793 49.9223 11.6742 49.3241 14.6938 46.3045ZM10.777 43.2173C9.80262 44.1917 8.02752 44.4715 6.79266 44.539C6.02088 44.5873 5.4131 43.9698 5.45169 43.1981C5.51922 41.9632 5.80864 40.1881 6.77337 39.2137C7.87316 38.1139 9.66756 38.1139 10.7673 39.2137C11.8671 40.3135 11.8671 42.1079 10.7673 43.2077L10.777 43.2173Z" fill="#FFDE00"/>
      </svg>
      <div class="onboarding-inner-content">
        <h3>{{ slide.title }}</h3>
        <p v-if="slide.paragraph">{{ slide.paragraph }}</p>
      </div>
    </div>

    <span class="fetching"></span>
  </div>
</template>

<script>
  import API from "app/axios.js";
  export default {
    props: {
      meta: {
        type: Object,
      },
      slide: {
        type: Object,
      },
    },

    data() {
      return {
        bOnce: false,
      }
    },

    mounted () {
      this.$emit('swiperUpdate');
    },

    computed: {
      isLoggedIn() {
        return this.$store.getters.isLoggedIn;
      },

      isNourish2() {
        return this.$store.getters.isNourish2;
      },
    },

    methods: {
      async handleUpgrade() {
        console.log(`Finalise: handleUpgrade(${this.isLoggedIn} && ${this.isNourish2})`);     
        if (this.isLoggedIn && this.isNourish2) {
          // okay .. only if we are ALREADY a N2 user.. 
          
          if (this.$coachingEngine.getOBxPickAvailable()) {
            // console.log(`STOP! -- Pick Available`);
            this.$coachingEngine.finaliseNextFocus();
            // and go next in 1s.. 
            window.setTimeout(() => {
              // reset the homepage, scroll up etc.
              this.EventBus.$emit('home:reset', 'Refocus');
              this.EventBus.$emit('device:boot', { mode: 'Auth', });
              this.next();
            }, 1000);
            return;
          } else if (this.$coachingEngine.getOBxTotalSteps()) {

            // CATCH: the user is already deep into onboarding... maybe a double tap or something... but we don't want to be fucking about with upgrades!

            // console.log(`STOP! -- We shouldn't be here!?`);

            // EXCEPT ... DON'T STOP ... because perhaps we're now setting the first getOBxTotalSteps() just seconds before we hit here ... and then we're failing to upgrade them?



            // window.setTimeout(() => {
            //   this.next();
            // }, 1000);
            // return;
          }
        }

        // Check if the user is Nourish 2. If not, upgrade them
        if (this.isLoggedIn && !this.isNourish2) {
          await this.patchUpgradeUser();
        }

        // Clear the onboarding memo
        this.$userEngine.clearOnboardMemo();

        // reset the homepage, scroll up etc.
        setTimeout(() => {
          this.EventBus.$emit('home:reset', 'Finalise');
          this.EventBus.$emit('device:boot', { mode: 'Auth', });
        }, 1000);

        // Go next
        this.next();
      },

      async patchUpgradeUser() {
        console.log(`Finalise: patchUpgradeUser(${this.bOnce})`);   
        // add the onboarding memo.. 
        if (this.bOnce) {
          // console.log(`Upgrade cancelled!?...`, this.bOnce);
          return false;
        }

        // checking for double-hit bugs. weird.
        // console.log(`Upgrading...`, this.bOnce);
        this.bOnce = true;

        // build the payload
        let oPayload = {
          memo: JSON.stringify(this.$userEngine.getOnboardMemo())
        };

        // run the upgrade!
        await API.patch(`/account/upgrade`, oPayload).then((response) => {  
          if (response.status.toString().substring(0,1) == 2) { // 2xx - success
            this.$store.commit("updateAccount", response.data);
          }
          
          // Plausible tracking: (User account created)
          this.EventBus.$emit('track:event', {
            label: 'SignUp: Upgrade',
            once: true, // default
          });

          this.next();
        }).catch(() => { // error
          this.isWorking = false;
          // this.handleResponseError(error);
        });

        return true
      },

      next() {
        this.EventBus.$emit('tab:hide-next', false)
        this.$emit('next')
      }
    },

    watch: {
      '$route.params.stack': {
        handler(slug) {
          console.log(`Finalse checking: does ${slug} == ${this.slide.slug} ??`);
          if (slug === this.slide.slug) {
            this.EventBus.$emit('tab:hide-next', true)
            this.handleUpgrade()
          }
        },
        immediate: true,
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .onboarding-content {
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    padding-top: 2rem;

    .onboarding-inner-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 1rem;
      max-width: 450px;
      margin: 0 auto;
    }

    svg path {
      fill: $yellow-tone-4;

      .darkmode & {
        fill: $yellow-tone-3;
      }
    }
  }

  h3 {
    font-family: 'Brawler';
    font-weight: normal;
    font-size: 38px;
    line-height: 110%;
    text-align: left;
    text-wrap: balance;

    .desktop & {
      font-size: 50px;
      text-align: center;
    }
  }

  p {
    font-size: 20px;
    line-height: 150%;
    text-wrap: balance;
  }

  .fetching {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    animation: rotate 1s linear infinite;
    align-self: center;
    margin-top: 3rem;

    &:before {
      content: "";
      box-sizing: border-box;
      position: absolute;
      inset: 0px;
      border-radius: 50%;
      animation: prixClipFix 2s linear infinite;
      border: 5px solid $neutral-100;

      .darkmode & {
        border: 5px solid $neutral-600;
      }
    }
  }
</style>